var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRow',{staticClass:"d-flex justify-center"},_vm._l((_vm.widgets),function(widget,widgetIndex){return _c('VCol',{key:widgetIndex},[_c('HomeWidget',{attrs:{"widget":widget}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }